module.exports = __webpack_public_path__ + "img/section1Swiper4.6645d001.png";